// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__dYfu8","purple":"Badge_purple___zDNn","blue":"Badge_blue__q6iM7","red":"Badge_red__800Tx","orange":"Badge_orange__rh75d","green":"Badge_green__2gsQ6"};